module.exports = __webpack_public_path__ + "static/media/add-ship.6e60a7be.svg";